import "./uploadbuilding.css";
import "@esri/calcite-components/components/calcite-block";
import "@esri/calcite-components/components/calcite-notice";
import "@esri/calcite-components/components/calcite-link";
import "@esri/calcite-components/components/calcite-button";
import "@esri/calcite-components/components/calcite-action";
import "@esri/calcite-components/components/calcite-dialog";
import "@esri/calcite-components/components/calcite-input";
import "@esri/calcite-components/components/calcite-alert";
import { useEffect, useRef, useState } from "react";

import DataValidation from "./validation/DataValidation.js";
import InsertBuilding from "./insertbuilding/InsertBuilding.js";
import { sharedQueue } from "./layerlist/Queue.js";
import texts from "../../../assets/texts/texts.js";

const validateData = new DataValidation();

let atributs = null;

function UploadModel({ onChange, setProjectListInput }) {
  const insertBuilding = new InsertBuilding();

  const [uploadFileNotice, setUploadFileNotice] = useState(false);
  const [notionAtributs, setNotionAtributs] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectValue, setProjectValue] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const dropFileHandler = (event) => {
    let files;
    // Prevent the browsers default drop behavior, so it doesn't try to open the file
    let file;
    if (event.type !== "change") {
      event.preventDefault();
      // Makes sure the items we're dealing with are a File
      files = event.dataTransfer.items
        ? Array.from(event.dataTransfer.items)
            .filter((item) => item.kind === "file")
            .map((item) => item.getAsFile())
        : Array.from(event.dataTransfer.files);
      const [filet] = files;
      file = filet;
    } else {
      const isFile = event.target.files?.[0];
      //if (!isFile) return;
      file = isFile;
    }

    if (file) {
      //const fileCheck = checkFile(file);
      const validation = validateData.validate(file);

      validation.then((value) => {
        if (value.kind === "success") {
          if (value.from === "GLB") {
            insertBuilding.fromGLBfile(validateData.file).then((mesh) => {
              onChange(mesh);
            });
            setNotionAtributs({
              kind: "success",
              message: "insertbyhand",
              from: "GLB",
            });
            setUploadFileNotice(false);
            setTimeout(() => {
              setUploadFileNotice(true);
            }, 10);
          }
          if (value.from === "WebApp") {
            insertBuilding.fromWebApp(validateData.zipFiles).then((values) => {
              setOpenDialog(true);
              setProjectValue(values);
              setProjectName(values.name);
            });
          }

          if (value.from === "ArcGIS") {
            insertBuilding
              .fromArcGISpro(validateData.zipFiles, false)
              .then((values) => {
                setOpenDialog(true);
                setProjectValue(values);
                setProjectName(values.name);
              });
          }
          setUploadFileNotice(false);
        } else if (value.message === "ziszero"){
       insertBuilding
              .fromArcGISpro(validateData.zipFiles, true)
              .then((values) => {
                setOpenDialog(true);
                setProjectValue(values);
                setProjectName(values.name);
              });
        }   else {
          setUploadFileNotice(false);
          setTimeout(() => {
            setUploadFileNotice(true);
          }, 10);
        }

        setNotionAtributs(value);
        atributs = value;
      });
    }
  };

  const dialogRef = useRef(null);
  const closeReasonRef = useRef(null); // "confirm" | "close-x" | null

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    const onBeforeClose = (e) => {
      if (closeReasonRef.current) return;
      closeReasonRef.current = "other";
    };

    const onClose = () => {
      const reason = closeReasonRef.current;
      // If confirm by upload button
      if (reason === "confirm") {
        setNotionAtributs(atributs);
        setOpenDialog(false);
      } else {
        if (notionAtributs.kind !== "success") {
          setNotionAtributs({
            kind: "warning",
            message: "notupload",
            from: "ArcGIS",
          });
          setOpenDialog(false);
        }
      }
      setUploadFileNotice(true);
      closeReasonRef.current = null;
    };

    dialog.addEventListener("calciteDialogBeforeClose", onBeforeClose);
    dialog.addEventListener("calciteDialogClose", onClose);

    return () => {
      dialog.removeEventListener("calciteDialogBeforeClose", onBeforeClose);
      dialog.removeEventListener("calciteAlertBeforeOpen", onClose);
    };
  }, []);

  return (
    <>
      <calcite-dialog
        overlayPositioning="fixed"
        open={openDialog}
        modal
        width="s"
        heading={texts.widgets.uploadmodel.upload.projectname.title}
        id="changeProjectName"
        closeDisabled={false} // disable ?????
        ref={dialogRef}
      >
        <p id="example-content">
          <calcite-input
            onInput={(e) => setProjectName(e.target.value)}
            id="changeProjectNameInput"
            value={projectName}
            placeholder={
              texts.widgets.uploadmodel.upload.projectname.placeholder
            }
          ></calcite-input>
        </p>

        <calcite-button
          onClick={() => {
            // If it's not set name set to default
            let projektTitle = projectName;
            if (projectName === "") {
              projektTitle =
                texts.widgets.uploadmodel.upload.projectname.projecttitle;
            }
            sharedQueue.enqueue({
              name: projektTitle,
              mesh: projectValue.mesh,
              id: projectValue.id,
            });

            setProjectListInput({
              name: projectName,
              mesh: projectValue.mesh,
              id: projectValue.id,
            });

            insertBuilding.addGraphicToWiew({
              name: projectName,
              mesh: projectValue.mesh,
              id: projectValue.id,
            });
            setOpenDialog(false);

            closeReasonRef.current = "confirm";
            dialogRef.current.open = false;
          }}
          id="changeProjectNameAdd"
          slot="footer"
          icon-start="upload"
        >
          {texts.widgets.uploadmodel.upload.projectname.button}
        </calcite-button>
      </calcite-dialog>
      <calcite-block
        id="downloadHeader"
        scale="l"
        collapsible
        heading={texts.widgets.uploadmodel.upload.title}
        icon-start="upload"
        icon-start-scale="l"
        className="my-wrapper"
      >
        <calcite-panel
          id="dropZone"
          menu-placement="bottom-end"
          scale="l"
          className=" esri-component"
          ondrop={dropFileHandler}
          ondragover={(event) => event.preventDefault()}
        >
          <div>
            <label>
              <input onChange={dropFileHandler} id="uploadImput" type="file" />
            </label>
            <section className="dropZone__container">
              <calcite-button
                id="upload-model-button"
                icon-end="files"
                label="Browse files"
                alignment="icon-start-space-between"
                appearance="solid"
                kind="brand"
                scale="m"
                split-child="false"
                type="button"
                width="auto"
                calcite-hydrated=""
                onClick={() => {
                  document.querySelector("#uploadImput").click();
                }}
              >
                {texts.widgets.uploadmodel.upload.dropfield.button}
              </calcite-button>
              <p>{texts.widgets.uploadmodel.upload.dropfield.description}</p>
              <p className="dropZone__error errorText"> </p>
            </section>
          </div>
        </calcite-panel>
        <calcite-notice
          id="uploadNotice"
          open
          icon="information"
          className="margin_top"
        >
          <div slot="message">{texts.widgets.uploadmodel.upload.info}</div>
          <calcite-link
            slot="link"
            href={texts.widgets.uploadmodel.upload.descriptionsURL}
            target="_blank"
          >
            {texts.description}: {texts.widgets.uploadmodel.upload.title}
          </calcite-link>
        </calcite-notice>

        {uploadFileNotice && (
          <calcite-alert
            id="uploadAlert"
            open={uploadFileNotice}
            kind={notionAtributs.kind}
            auto-close
            auto-close-duration="medium"
          >
            <div slot="title">
              {
                texts.widgets.uploadmodel.upload.validation[
                  notionAtributs.kind
                ][notionAtributs.message].title
              }
            </div>
            <div slot="message">
              {
                texts.widgets.uploadmodel.upload.validation[
                  notionAtributs.kind
                ][notionAtributs.message].message
              }
            </div>
          </calcite-alert>
        )}
      </calcite-block>
    </>
  );
}

export default UploadModel;
